<nav class="navigation">
    <div class="l-nav-item">
        <img routerLink="/" role="button" src="images/png/logo/logo_PMU_Mali.png" alt="logo PMU Mali">
        <!-- <div class="date">Lun. 25 nov.<p class="">12h00</p></div> -->
        <app-date-time [currentLocal]="selectedLang"></app-date-time>
    </div>
    <div class="r-nav-item">
        <img role="button" src="images/svg/info-circle 1.svg" alt="icon_infos">
        <div class="lang-selection" id="langue-selection" (click)="toggleDropdown()" role="button">
          <img [src]="`images/png/${selectedLang}.png`" [alt]="'lang.' + selectedLang | translate">
          <span class="selected">{{'lang.' + selectedLang | translate}}</span>
          <div class="arrow-down" [style.maskImage]="`url(images/svg/chevron-down.svg)`"></div>
          @if (dropdownOpen) {
            <div class="lang-options" [class.open]="animate" [class.close]="!animate">
              @for (language of languages; track $index; let i = $index) {
                <div class="lang-option" (click)="changeLanguage(i)">
                  <img [src]="`images/png/${language}.png`" [alt]="'lang.' + language | translate">
                  <span>{{'lang.' + language | translate}}</span>
                </div>
              }
            </div>
          }
        </div>
    </div>
</nav>
